import axiosInstance from '../../../config/axiosInstance';
const StockNotesService = {
    async GetStockNotes(redirectCallback, StockID) {
        try {
            const response = await axiosInstance.get(`/Part/GetStockNotes?StockID=${StockID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteStockNotes(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/DeleteStockNotes?ID=${ID}`);
            return response.data;
        } catch (error) {
            
            console.error('Error fetching data:', error);
            throw error;
        }
    },    
};

export default StockNotesService;